import { render, staticRenderFns } from "./RipaFormSummary.vue?vue&type=template&id=5ff00acd"
import script from "./RipaFormSummary.vue?vue&type=script&lang=js"
export * from "./RipaFormSummary.vue?vue&type=script&lang=js"
import style0 from "./RipaFormSummary.vue?vue&type=style&index=0&id=5ff00acd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports